import { Search as SearchIcon } from '@mui/icons-material'
import { IconButton, Stack, StackProps, Switch, TextField, Typography } from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { searchSubmit } from 'app/search/searchSlice'
import { selectSearchQuery } from 'app/selectors'
import { clearFilters } from 'app/thunks'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

type SearchFormProps = StackProps<'form'>

const SearchForm = (props: SearchFormProps) => {
  const dispatch = useAppDispatch()

  const searchQuery = useSelector(selectSearchQuery)
  const [inputText, setInputText] = useState(searchQuery)
  const [searchType, setSearchType] = useState<'products' | 'brands'>('products')

  useEffect(() => {
    setInputText(searchQuery)
  }, [searchQuery, setInputText, setSearchType])

  const handleSubmit: React.FormEventHandler = (ev) => {
    ev.preventDefault()
    dispatch(clearFilters());
    dispatch(searchSubmit({ search: inputText, type: searchType }))
  }

  return (
    <Stack>
      <Stack flexDirection={'row'} alignItems={'center'} mb={1}>
        <Typography variant={'detail'}>Searching for</Typography>
        <Typography variant={'detail'} color={searchType === 'products' ? '#000000' : '#BDBDBD'} ml={0.5}>Products</Typography>
        <Switch
          size='small'
          onChange={
            (ev) => {
              setSearchType(ev.target.checked ? 'brands' : 'products')
            }
        } />
        <Typography variant={'detail'} color={searchType === 'brands' ? '#000000' : '#BDBDBD'} ml={0.5}>Brands</Typography>
      </Stack>
      <Stack
        component={'form'}
        direction={'row'}
        onSubmit={handleSubmit}
        {...props}
      >
        <TextField
          variant="outlined"
          sx={{ width: '100%' }}
          name="search"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder={`Search ${searchType}...`}
        />
        <IconButton
          type="submit"
          sx={{ bgcolor: 'primary.main', borderRadius: 0, width: '2em' }}
          children={<SearchIcon />}
        />
      </Stack>
    </Stack>
  )
}

export default SearchForm
